import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-criteria',
  imports: [],
  templateUrl: './criteria.component.html',
  styleUrl: './criteria.component.css'
})
export class CriteriaComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Criteria';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inclusionCriteria: any[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exclusionCriteria: any[] = [];
  private usdmSub: Subscription | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'OsbUploadResponse') {
        if (item.message.includes('All criteria extracted successfully.')) {
          this.usdm.criteria = item.data;
          this.data = item.data;
          this.extractCriteria();
          this.usdm.signalStateCompletion(this.stateName);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

  extractCriteria(): void {
    if (!this.data) return;

    for (const criterion of this.data.eligibilityCriteria) {
      if (criterion.category.code === 'C25532') {
        for (const item of this.data.eligibilityCriterionItems) {
          if (item.id === criterion.criterionItemId) {
            this.inclusionCriteria.push(item.text);
          }
        }
      } else {
        for (const item of this.data.eligibilityCriterionItems) {
          if (item.id === criterion.criterionItemId) {
            this.exclusionCriteria.push(item.text);
          }
        }
      }
    }
  }

}
